import { VerificationDocumentsHelper } from "app/helpers/verificationDocumentsHelper";
import type { VerificationDocumentType } from "app/types/documentType";
import { DocumentCategory } from "app/utils/const";
import React from "react";
import { FormattedMessage, IntlShape } from "react-intl";
import DocumentListView from "../DocumentListView/DocumentListView";
import "./DocumentCategorySelector.scss";

type Props = {
  title: string;
  description?: string;
  buttonText?: string;
  onSelect: () => void;
  disabled: boolean;
  documentList: VerificationDocumentType[];
  updateDocumentList: () => void;
  category: string;
  intl: IntlShape;
};

const DocumentCategorySelector: React.FC<Props> = ({
  title,
  description,
  buttonText,
  onSelect,
  disabled,
  documentList,
  updateDocumentList,
  category,
  intl,
}) => {
  const identityRequirementsOK =
    VerificationDocumentsHelper.verifyIdUploaded(documentList, intl) === "";
  const poaRequirementsOK =
    VerificationDocumentsHelper.verifyProofOfAddressUploaded(
      documentList,
      intl
    ) === "";
  return (
    <div className="document-upload">
      <div className="document-upload-content">
        <h3>{title}</h3>
        <DocumentListView
          updateDocumentList={updateDocumentList}
          documentList={documentList}
        />
        {category === DocumentCategory.IDENTITY && !identityRequirementsOK && (
          <>
            {description && <p>{description}</p>}
            <button
              className="document-upload__button"
              onClick={onSelect}
              disabled={disabled}
            >
              {buttonText}
            </button>
          </>
        )}
        {category === DocumentCategory.PROOFOFADDRESS && !poaRequirementsOK && (
          <>
            {description && <p>{description}</p>}
            <button
              className="document-upload__button"
              onClick={onSelect}
              disabled={disabled}
            >
              {buttonText}
            </button>
          </>
        )}
      </div>
      <p className="document-upload__secure-message">
        <FormattedMessage
          id="account-verification-secure"
          defaultMessage="Your upload is secure"
        />
      </p>
    </div>
  );
};

export default DocumentCategorySelector;
